import React from 'react'
import { useState,useEffect } from 'react';
import Breadcrumbs from '../../components/Common/Breadcrumb'
import Table from 'react-bootstrap/Table';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { Row,Button, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label,Select } from "reactstrap";


export default function Reports() {
    const[email, setEmail] = useState("");
    const[storeID, setStoreid] = useState('');
    const[orders, setAllorders] = useState([]);
    const[start,setStart] = useState('');
    const[end,setEnd] = useState('');
    const[status,setStatus] = useState('');
    const[company, setCompany] = useState('');
    const[efficency, setEfficiency] = useState('');
    const[paymentType, setPaymenttype] = useState('');
    const[deliveryType, setDeliverymethod] = useState('');
    const[search, setSearch] = useState('');
    const[companies, setCompanies] = useState([])
    const [userrole, setUserrole] = useState('')

    
    useEffect(()=>{
    const fetchData = async()=>{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getAttachedcompanies?store=${storeID}`)
        const data = await res.json();
        setCompanies(data)
    }

    if(storeID){
        fetchData();
    }
},[storeID])
    

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch('https://easyboxstoresapi.uuidesign.xyz/api/profile', {
          credentials: 'include', // to send cookies
        });
        const data = await res.json();

        if (data.valid) {
          setEmail(data.email)
        } else {}
      } catch (error) {} 
    };

    fetchProfile();
  }, []);

  //get store id
  useEffect(()=>{
   const fetchData = async()=>{
      try{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getUserdetails?email=${email}`);
        const data = await res.json();
        setStoreid(data.store_id)
        setUserrole(data.role)
      }
      catch(err){}
   }

   if(email){
    fetchData();
   }
   
  },[email])

  useEffect(()=>{
    const fetchData =async()=>{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getAllorders?store=${storeID}`);
        const data = await res.json();

        setAllorders(data)
    }

    if(storeID){
        fetchData();  
    }

  },[storeID])

  const fetchOrders =async()=>{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getAllorders?store=${storeID}`);
        const data = await res.json();

        setAllorders(data)
    }

  useEffect(()=>{
    const fetchData=async()=>{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/searchOrder?search=${search}&store=${storeID}`);
        const data = await res.json();
        setAllorders(data)
    }

    if(search !=''){
        fetchData();
    }
    if(search == ''){
        fetchOrders();
    }
  },[storeID,search])

  const handleDateChange = (e) => {
        const dateTime = e.target.value;
        const millisecondsSinceEpoch = new Date(dateTime).getTime();
        setStart(millisecondsSinceEpoch);
    
      };
      const handleDateChange2 = (e) => {
        const dateTime = e.target.value;
        const millisecondsSinceEpoch = new Date(dateTime).getTime();
        setEnd(millisecondsSinceEpoch);
       
      };

      const exportToPdf = () => {
        const doc = new jsPDF();
    
        // Add a title to the PDF
        doc.text("Easybox_report", 20, 10);
    
        // Extract table headers and rows from the DOM
        const table = document.getElementById("dataTable");
        const headers = Array.from(
          table.querySelectorAll("thead tr th")
        ).map((header) => header.textContent);
    
        const rows = Array.from(table.querySelectorAll("tbody tr")).map((row) =>
          Array.from(row.querySelectorAll("td")).map((cell) => cell.textContent)
        );
    
        // Generate the PDF table
        doc.autoTable({
          head: [headers],
          body: rows,
          startY: 20,
        });
    
        // Save the PDF
        doc.save("Easybox_report.pdf");
      };
  return (
    <div className='ordersContainer'>
          <Breadcrumbs title="Easybox" breadcrumbItem="Reports" />
          <div className="card" style={{padding:'10px'}}>
            {userrole !== 'Admin' &&
                <p>You do not have permission</p>
            }
            {userrole == 'Admin' &&
            <>
            <div className="searchBar">
            <div className="mb-4" >
                <Label className="form-label">Search order</Label>
                <Input
                    name="search"
                    className="form-control"
                    placeholder="Search order"
                    type="text"
                    onChange={(e)=>{setSearch(e.target.value)}}
                    value={search}

                />
                
            </div>

        </div>
        <h5>Filter</h5>
        <div className="filterBar">
            <div className="flt">
            <div className="mb-4" id='mb'>
                <Label className="form-label">From date</Label>
                <Input
                    name="text"
                    className="form-control"
                    placeholder="Search order"
                    type="datetime-local"
                    onChange={handleDateChange}
                    // value={email}

                />
                
            </div>
            <div className="mb-4" id='mb'>
                <Label className="form-label">To date</Label>
                <Input
                    name="text"
                    className="form-control"
                    placeholder="Search order"
                    type="datetime-local"
                    onChange={handleDateChange2}
                    // value={email}

                />
                
            </div>

            </div>

            <div className="flt">
            <div className="mb-4" id='mb'>
                <Label className="form-label">Delivery Company</Label>
                <select name="" id="" className="form-control" onChange={(e)=>{setCompany(e.target.value)}}>
                    <option selected disabled>Select Logistics companies</option>
                    <option value=''>All</option>
                    {companies.map((val)=>{
                        return(
                            <option value={val.uniqueID}>{val.companyName}</option>
                        )
                    })}      
                   
                </select>
                
            </div>
            <div className="mb-4" id='mb'>
                <Label className="form-label">Status</Label>
                <select name="" id="" className="form-control" onChange={(e)=>{setStatus(e.target.value)}}>
                    <option selected disabled>Status</option>
                    <option value="Pending">Pending</option>
                    <option value="Dispatch">Dispatch</option>
                    <option value="Transit">Transit</option>
                    <option value="Delivered">Delivered</option>
                    <option value="Cancelled">Cancelled</option>
                </select>
                
            </div>
            

            <div className="mb-4" id='mb'>
                <Label className="form-label">Delivery type</Label>
                <select name="" id="" className="form-control" onChange={(e)=>{setDeliverymethod(e.target.value)}}>
                    <option selected value=''>Delivery type</option>
                    <option value="Normal delivery">Normal delivery</option>
                    <option value="Bulk delivery">Bulk delivery</option>
                </select>
                
            </div>


            </div>
           
           
        </div>

        <div className="card">
        <div className="">
        <Button color='success' onClick={exportToPdf}>Export to PDF</Button>
        </div>
        <div className="card-body">
        <div className="table-responsive">

            <Table striped bordered hover  id="dataTable">

                <thead>
                    <tr>
                        <th scope="col">Order Number</th>
                        <th scope="col">Date</th>
                        <th scope="col">Delivery company</th>
                        <th scope="col">Customer</th>
                        <th scope="col">Contact</th>
                        <th scope="col">Location</th>
                        <th scope="col">Status</th>
                    </tr>
                </thead>
                <tbody>
                {orders.map((val)=>{
                    const postDate = new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(val.createdAt)
                    const postTime =  new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(val.createdAt)

                    if(start == '' && end == '' && company == '' && status == '' && efficency == '' && paymentType == '' && deliveryType == ''){
                        return(
                        <tr>
                        <td>{val.orderNumber}</td>
                        <td>{postDate},{postTime}</td>
                        <td>{val.allocatedCompany}</td>
                        <td>{val.customerName}</td>
                        <td>{val.customerPhone}</td>
                        <td>{val.deliveryLocation}</td>
                        <td>
                        {val.status == 'Delivered' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "success"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Pending' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Cancelled' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Transit' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "info"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Dispatch' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "warning"}></i> {val.status}
                            </>
                        }
                        </td>
                       
                        </tr>
                    )

                    }

                    
                    if(start < val.createdAt && end > val.createdAt && company == '' && status == ''  && deliveryType == ''){
                        return(
                        <tr>
                        <td>{val.orderNumber}</td>
                        <td>{postDate},{postTime}</td>
                        <td>{val.allocatedCompany}</td>
                        <td>{val.customerName}</td>
                        <td>{val.customerPhone}</td>
                        <td>{val.deliveryLocation}</td>
                        <td>
                        {val.status == 'Delivered' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "success"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Pending' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Cancelled' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Transit' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "info"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Dispatch' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "warning"}></i> {val.status}
                            </>
                        }
                        </td>
                       
                        </tr>
                    )

                    }

                    if(start < val.createdAt && end > val.createdAt && company == val.allocatedCompany && status == ''  && deliveryType == ''){
                        return(
                        <tr>
                        <td>{val.orderNumber}</td>
                        <td>{postDate},{postTime}</td>
                        <td>{val.allocatedCompany}</td>
                        <td>{val.customerName}</td>
                        <td>{val.customerPhone}</td>
                        <td>{val.deliveryLocation}</td>
                        <td>
                        {val.status == 'Delivered' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "success"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Pending' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Cancelled' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Transit' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "info"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Dispatch' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "warning"}></i> {val.status}
                            </>
                        }
                        </td>
                       
                        </tr>
                    )

                    }

                    
                    if(start == '' && end == '' && company == val.allocatedCompany && status == ''  && deliveryType == ''){
                        return(
                        <tr>
                        <td>{val.orderNumber}</td>
                        <td>{postDate},{postTime}</td>
                        <td>{val.allocatedCompany}</td>
                        <td>{val.customerName}</td>
                        <td>{val.customerPhone}</td>
                        <td>{val.deliveryLocation}</td>
                        <td>
                        {val.status == 'Delivered' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "success"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Pending' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Cancelled' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Transit' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "info"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Dispatch' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "warning"}></i> {val.status}
                            </>
                        }
                        </td>
                       
                        </tr>
                    )

                    }

                    
                    if(start < val.createdAt && end > val.createdAt && company == val.allocatedCompany && status == val.status  && deliveryType == ''){
                        return(
                        <tr>
                        <td>{val.orderNumber}</td>
                        <td>{postDate},{postTime}</td>
                        <td>{val.allocatedCompany}</td>
                        <td>{val.customerName}</td>
                        <td>{val.customerPhone}</td>
                        <td>{val.deliveryLocation}</td>
                        <td>
                        {val.status == 'Delivered' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "success"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Pending' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Cancelled' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Transit' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "info"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Dispatch' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "warning"}></i> {val.status}
                            </>
                        }
                        </td>
                       
                        </tr>
                    )

                    }

                    
                    if(start < val.createdAt && end > val.createdAt && company == '' && status == val.status  && deliveryType == ''){
                        return(
                        <tr>
                        <td>{val.orderNumber}</td>
                        <td>{postDate},{postTime}</td>
                        <td>{val.allocatedCompany}</td>
                        <td>{val.customerName}</td>
                        <td>{val.customerPhone}</td>
                        <td>{val.deliveryLocation}</td>
                        <td>
                        {val.status == 'Delivered' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "success"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Pending' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Cancelled' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Transit' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "info"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Dispatch' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "warning"}></i> {val.status}
                            </>
                        }
                        </td>
                       
                        </tr>
                    )

                    }

                    
                    if(start =='' && end =='' && company == val.allocatedCompany && status == val.status  && deliveryType == ''){
                        return(
                        <tr>
                        <td>{val.orderNumber}</td>
                        <td>{postDate},{postTime}</td>
                        <td>{val.allocatedCompany}</td>
                        <td>{val.customerName}</td>
                        <td>{val.customerPhone}</td>
                        <td>{val.deliveryLocation}</td>
                        <td>
                        {val.status == 'Delivered' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "success"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Pending' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Cancelled' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Transit' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "info"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Dispatch' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "warning"}></i> {val.status}
                            </>
                        }
                        </td>
                       
                        </tr>
                    )

                    }

                    
                    if(start < val.createdAt && end > val.createdAt && company == val.allocatedCompany && status == val.status  && deliveryType == val.deliveryType){
                        return(
                        <tr>
                        <td>{val.orderNumber}</td>
                        <td>{postDate},{postTime}</td>
                        <td>{val.allocatedCompany}</td>
                        <td>{val.customerName}</td>
                        <td>{val.customerPhone}</td>
                        <td>{val.deliveryLocation}</td>
                        <td>
                        {val.status == 'Delivered' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "success"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Pending' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Cancelled' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Transit' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "info"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Dispatch' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "warning"}></i> {val.status}
                            </>
                        }
                        </td>
                       
                        </tr>
                    )

                    }

                    
                    if(start < val.createdAt && end > val.createdAt && company == '' && status == ''  && deliveryType == val.deliveryType){
                        return(
                        <tr>
                        <td>{val.orderNumber}</td>
                        <td>{postDate},{postTime}</td>
                        <td>{val.allocatedCompany}</td>
                        <td>{val.customerName}</td>
                        <td>{val.customerPhone}</td>
                        <td>{val.deliveryLocation}</td>
                        <td>
                        {val.status == 'Delivered' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "success"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Pending' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Cancelled' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Transit' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "info"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Dispatch' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "warning"}></i> {val.status}
                            </>
                        }
                        </td>
                       
                        </tr>
                    )
                    }

                    
                    if(start == '' && end == '' && company == val.allocatedCompany && status == val.status  && deliveryType == val.deliveryType){
                        return(
                        <tr>
                        <td>{val.orderNumber}</td>
                        <td>{postDate},{postTime}</td>
                        <td>{val.allocatedCompany}</td>
                        <td>{val.customerName}</td>
                        <td>{val.customerPhone}</td>
                        <td>{val.deliveryLocation}</td>
                        <td>
                        {val.status == 'Delivered' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "success"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Pending' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Cancelled' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Transit' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "info"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Dispatch' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "warning"}></i> {val.status}
                            </>
                        }
                        </td>
                       
                        </tr>
                    )

                    }

                    if(start == '' && end == '' && company == val.allocatedCompany && status == ''  && deliveryType == val.deliveryType){
                        return(
                        <tr>
                        <td>{val.orderNumber}</td>
                        <td>{postDate},{postTime}</td>
                        <td>{val.allocatedCompany}</td>
                        <td>{val.customerName}</td>
                        <td>{val.customerPhone}</td>
                        <td>{val.deliveryLocation}</td>
                        <td>
                        {val.status == 'Delivered' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "success"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Pending' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Cancelled' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Transit' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "info"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Dispatch' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "warning"}></i> {val.status}
                            </>
                        }
                        </td>
                       
                        </tr>
                    )

                    }

                    if(start == '' && end == '' && company == '' && status == val.status  && deliveryType == val.deliveryType){
                        return(
                        <tr>
                        <td>{val.orderNumber}</td>
                        <td>{postDate},{postTime}</td>
                        <td>{val.allocatedCompany}</td>
                        <td>{val.customerName}</td>
                        <td>{val.customerPhone}</td>
                        <td>{val.deliveryLocation}</td>
                        <td>
                        {val.status == 'Delivered' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "success"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Pending' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Cancelled' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Transit' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "info"}></i> {val.status}
                            </>
                        }
                        {val.status == 'Dispatch' &&
                            <>
                                <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "warning"}></i> {val.status}
                            </>
                        }
                        </td>
                       
                        </tr>
                    )

                    }


                    

                   
                    
                })}
                    
                </tbody>
            </Table>
        </div>
    </div>
    </div>
            </>
            
            
            }
          </div>
    </div>
  )
}
